import { StatusCodes } from 'http-status-codes';
import { useEffect, useState } from 'react';
import TableWrapper from '~/src/components/common/forms/TableWrapper/TableWrapper';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import FnbApi from '~/src/services/api/FnbApi';
import FnbItemRow from '../components/FnbItemRow';
import { useHistory } from 'react-router-dom';

export default function FnbProductsNoMatch(): JSX.Element {
  const [fnbItems, setFnbItems] = useState([]);
  const history = useHistory();
  
  const get = async () => {
    const res = await FnbApi.get();

    if (res.status === StatusCodes.OK) {
      setFnbItems(res.data);
    }
  };

  useEffect(() => {
    get();
  }, []);

  return (
    <WhitePad isFluid>
      <TitleComponent title="Fnb Products without Matches" 
       titleLeft="Back"
       onLeftHandler={(): void => history.goBack()}
       />
      <TableWrapper>
        <thead>
          <tr>
            <th>FnbId</th>
            <th>Fnb GTIN</th>
            <th>Fnb Name</th>
            <th>Svila Gtin</th>
          </tr>
        </thead>
        <tbody>
          {fnbItems?.map((fnbItem) => {
            return <FnbItemRow fnbItem={fnbItem} />;
          })}
        </tbody>
      </TableWrapper>
    </WhitePad>
  );
}
